import * as yup from "yup"
import { t } from "i18next"

export const paidLeaveFormSchema = yup.object().shape({
  paidLeave: yup.number().required(t("Please enter")),
  grantDate: yup.string().required(t("Please select")),
})
